module.exports = __webpack_public_path__ + "img/activate-result.05fb23b9.png";